/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in this browser session */
  static #STORAGE_KEY = 'viewedProducts';

  /** @static @constant {string} Fired on `document` whenever the list changes in this tab. */
  static CHANGE_EVENT = 'recently-viewed:change';

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    if (!productId) return;
    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
    viewedProducts.unshift(productId);
    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
    document.dispatchEvent(new CustomEvent(this.CHANGE_EVENT));
  }

  /**
   * Drops products from the list, e.g. IDs that no longer match a published product.
   * @param {string[]} productIds - The IDs to remove.
   */
  static removeProducts(productIds) {
    const remove = new Set(productIds.map(String));
    const remaining = this.getProducts().filter((/** @type {string} */ id) => !remove.has(String(id)));
    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(remaining));
    document.dispatchEvent(new CustomEvent(this.CHANGE_EVENT));
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
    document.dispatchEvent(new CustomEvent(this.CHANGE_EVENT));
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
  }
}
